import React from 'react';
import { flowRight as compose } from 'lodash';
import withStyles from 'isomorphic-style-loader/withStyles';

import Loader from '../../../../components/Loader/Loader'

import WhyHostFormBlock6 from '../../../../components/siteadmin/WhyHostPageSettings/WhyHostFormBlock6/WhyHostFormBlock6'
import getWhyHostPageSettings from './getWhyHostPageSettings.graphql';
import { withQuery } from '../../../../hoc/withGraphql';
import s from './WhyHostBlock6.css';

const WhyHostBlock6 = (props) => {

    const { data: { loading, getWhyHostPage }, title } = props
    let settingsCollection = {}
    const dynamicMap = {};

    if (loading) {
        return <Loader type={"text"} />;
    } else {
        const BLOCK6_ACTIVE_FIELDS = ['peaceTitleHeading', 'peaceTitle3', 'peaceContent3'];
        getWhyHostPage?.forEach((item) => {
            settingsCollection[item.name] = item.value;

            if (BLOCK6_ACTIVE_FIELDS.includes(item.name)) {
                item.dynamicWhyHostInfoBlock?.forEach((dynItem) => {
                    if (!dynamicMap[dynItem.language]) {
                        dynamicMap[dynItem.language] = { language: dynItem.language };
                    }
                    dynamicMap[dynItem.language][dynItem.name] = dynItem.value;
                });
            }
        });

        const dynamicValues = Object.values(dynamicMap);
        settingsCollection.dynamicWhyHostInfoBlock = dynamicValues.length > 0
            ? dynamicValues
            : [{
                peaceTitleHeading: settingsCollection.peaceTitleHeading,
                peaceTitle3: settingsCollection.peaceTitle3,
                peaceContent3: settingsCollection.peaceContent3,
                language: 'en'
            }];

        return <WhyHostFormBlock6 initialValues={settingsCollection} title={title} />
    }
}

WhyHostBlock6.defaultProps = {
    data: {
        loading: false
    }
};

export default compose(
    withStyles(s),
    withQuery(getWhyHostPageSettings, {
        options: {
            fetchPolicy: 'network-only',
            ssr: false
        }
    }),
)(WhyHostBlock6);